module.exports = `:root {
  --primitiveColorNeutral0: #000000;
  --primitiveColorNeutral290: #3a474e;
  --primitiveColorNeutral350: #49545a;
  --primitiveColorNeutral400: #5a6063;
  --primitiveColorNeutral870: #d8dadc;
  --primitiveColorNeutral900: #e2e2e2;
  --primitiveColorNeutral950: #f2f2f2;
  --primitiveColorNeutral1000: #ffffff;
  --primitiveColorPrimary510: #d44500;
  --primitiveColorPrimary620: #fd6400;
  --primitiveColorPistachio780: #9cd081;
  --primitiveColorPistachio920: #e1ebc8;
  --primitiveColorAqua740: #65c6b7;
  --primitiveColorAqua900: #cce9dc;
  --primitiveColorForestgreen210: #0d3a2b;
  --primitiveColorFocus410: #005fcc;
  --primitiveColorError430: #a94442;
  --primitiveTypographyTypescaleDesktop1: 3rem;
  --primitiveTypographyTypescaleDesktop2: 2.375rem;
  --primitiveTypographyTypescaleDesktop3: 1.75rem;
  --primitiveTypographyTypescaleDesktop4: 1.5rem;
  --primitiveTypographyTypescaleDesktop5: 1.25rem;
  --primitiveTypographyTypescaleDesktop6: 1.125rem;
  --primitiveTypographyTypescaleDesktop7: 1rem;
  --primitiveTypographyTypescaleDesktop8: 0.875rem;
  --primitiveTypographyTypescaleMobile1: {primitive.typography.typescale.desktop.2;
  --primitiveTypographyTypescaleMobile2: {primitive.typography.typescale.desktop.3;
  --primitiveTypographyTypescaleMobile3: {primitive.typography.typescale.desktop.4;
  --primitiveTypographyTypescaleMobile4: {primitive.typography.typescale.desktop.5;
  --primitiveTypographyTypescaleMobile5: {primitive.typography.typescale.desktop.7;
  --primitiveTypographyTypescaleMobile6: {primitive.typography.typescale.desktop.8;
  --primitiveTypographyTypescaleMobile7: {primitive.typography.typescale.desktop.7;
  --primitiveTypographyTypescaleMobile8: {primitive.typography.typescale.desktop.8;
  --primitiveTypographyLineHeightDesktop1: 0.93;
  --primitiveTypographyLineHeightDesktop2: 1.105;
  --primitiveTypographyLineHeightDesktop3: 1.142;
  --primitiveTypographyLineHeightDesktop4: 1.167;
  --primitiveTypographyLineHeightDesktop5: 1.2;
  --primitiveTypographyLineHeightDesktop6: 1.222;
  --primitiveTypographyLineHeightDesktop7: 1.5;
  --primitiveTypographyLineHeightDesktop8: 1.429;
  --primitiveTypographyLineHeightMobile1: {primitive.typography.lineHeight.desktop.2;
  --primitiveTypographyLineHeightMobile2: {primitive.typography.lineHeight.desktop.3;
  --primitiveTypographyLineHeightMobile3: {primitive.typography.lineHeight.desktop.4;
  --primitiveTypographyLineHeightMobile4: {primitive.typography.lineHeight.desktop.5;
  --primitiveTypographyLineHeightMobile5: {primitive.typography.lineHeight.desktop.7;
  --primitiveTypographyLineHeightMobile6: {primitive.typography.lineHeight.desktop.8;
  --primitiveTypographyLineHeightMobile7: {primitive.typography.lineHeight.desktop.7;
  --primitiveTypographyLineHeightMobile8: {primitive.typography.lineHeight.desktop.8;
}
`;